import PouchDB from 'pouchdb'
import _ from 'lodash'
export default {
  async pull(params) {
    const db = new PouchDB(params.dbName)
    const remote = `${location.origin}/neocloud`
    try {
      const opts = {
        retry: false,
        batch_size: 1000,
        filter: 'sync_gateway/bychannel',
        query_params: {
          channels: params.channels
        }
      }
      const rep = await db.replicate.from(remote, opts)
      console.log('==== pull rep: ', rep)
      return rep
    } catch (err) {
      console.log('==== pull error: ', err)
      console.error(err)
    }
  },

  async push(dbName) {
    const db = new PouchDB(dbName)
    const remote = `${location.origin}/neocloud`
    try {
      const rep = await db.replicate.to(remote)
      return rep
    } catch (error) {
      throw new Error(error)
    }
  },

  // 获取书库数据
  async getLibraryChannel(params) {
    const db = new PouchDB(`${params.dbName}`)
    let data = await db.allDocs({
      include_docs: true
    })
    /**
     * modeType
     * 1：批注
     * 2：书签
     * 3：书架
     * 4：书籍
     */
    let arr = data.rows
      .map((item) => item.doc)
      .filter((item) => item.status === 0)
    arr = _.orderBy(arr, ['updatedAt'], ['desc'])
    let annotation = arr.filter((item) => item.modeType === 1)
    let bookMark = arr.filter((item) => item.modeType === 2)
    let library = arr.filter((item) => item.modeType === 3)
    let metadata = arr.filter((item) => item.modeType === 4)
    let res = { annotation, bookMark, library, metadata }
    console.log('======channelData: ', res)
    return res
  },

  async getChannel(params) {
    const db = new PouchDB(`${params.dbName}`)
    let data = await db.allDocs({
      include_docs: true
    })
    let arr = data.rows.map((item) => {
      item.doc.updatedAt = new Date(item.doc.updatedAt).getTime()
      return item.doc
    })
    arr = _.orderBy(arr, ['updatedAt'], ['desc'])
    return arr
  }
}
